export default {
  section: 'Compras',
  loading: 'Cargando compras...',
  headers: {
    uuid: 'No. de orden de compra',
    provider: 'Proveedor',
    area: 'Area',
    receiveDate: 'Fecha de recepción',
    amount: 'Monto'
  },
  labels: {
    dates: 'Fechas',
    provider: 'Proveedor',
    find: 'Buscar por uuid',
    download: 'Descargar CSV'
  },
  buttons: {
    purchasesCSV: 'Descargar CSV'
  }
}
